<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>DN Revenue Summer</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by From</u></label>
        <input type="date" [(ngModel)]="filterable.from" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by To</u></label>
        <input type="date" [(ngModel)]="filterable.to" class="form-control" placeholder="To">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source" (ngModelChange)="changeSource($event)">
          <option *ngFor="let source of sourceList" [ngValue]="source">{{source.name}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Country</u></label>
        <select #selectedCountry class="form-control" placeholder="Country" (change)="changeCountry(selectedCountry.value)">
          <option *ngFor="let country of countryList | keyvalue" [value]="country.value" [selected]="country.value == selectedCountry">{{country.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Report Type</u></label>
        <select [(ngModel)]="filterable.reportType" class="form-control" placeholder="Report Type" (ngModelChange)="changeReportType($event)">
          <option *ngFor="let report of reportTypeList | keyvalue" [value]="report.key">{{report.value}}</option>
        </select>
      </div>
      <!-- <div class="col">
        <label for=""><u>Data Flag</u></label>
        <select [(ngModel)]="filterable.realtime" class="form-control" placeholder="realtime">
          <option *ngFor="let rtf of realtimeFlags | keyvalue" [ngValue]="rtf.value">{{rtf.key}}</option>
        </select>
      </div> -->
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Items: {{totalItems}}<span  *ngIf="resultName != ''"  > - <span class="font-weight-bold font-italic text-danger">{{resultName}}</span> </span>
  </div>
  <div class="col-2 ml-auto text-right align-self-end">
    <button class="btn btn-primary btn-sm mr-2" (click)="search('csv')">Export CSV</button>
    <button class="btn btn-secondary btn-sm mr-2" (click)="search('excel')">Export Excel</button>
  </div>
</div>

<table id="dnChargeList" class="table table-striped table-bordered mt-3" style="width:100%">
  <thead class="text-center">
    <tr>
      <th>No.</th>
      <th>Label</th>
      <th>URL</th>
    </tr>
  </thead>
  <tbody *ngIf="!emptyResult">
    <tr *ngIf="loading">
      <td colspan="3">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="3">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let report of reports | keyvalue; index as i;">
        <td class="text-center">{{i + 1}}</td>
        <td class="text-left">{{report.key}}</td>
        <td class="text-left">
          <a href={{report.value}} target="_blank">{{report.value}}</a>
        </td>
    </tr>
  </tbody>
</table>
